<div class="w-full bg-fbf1fd rounded-lg p-2">
  <!-- title and total amount -->
  <div (click)="toggleAccordion('expense')"
    class="cursor-pointer pb-2 border-b border-483d8b flex items-center justify-between gap-2 group">
    <div class="flex items-center justify-start gap-4">
      <p class="text-sm sm:text-base xl:text-lg font-semibold text-483d8b">{{ expenseSummary.title }}</p>
      <div class="w-5 h-5 bg-white rounded-full flex items-center justify-center">
        <svg [class.rotate-180]="accordionState.expense"
          class="transition-transform duration-300 fill-8a8a8a group-hover:fill-0d5bab size-3" viewBox="0 0 20 20"
          fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.83398 8.3335L10.0007 12.5002L14.1673 8.3335H5.83398Z"></path>
        </svg>
      </div>
    </div>
    <p class="text-sm sm:text-base lg:text-lg font-semibold text-483d8b">₹ {{ expenseSummary.total | number:'1.2-2' }}
    </p>
  </div>

  <!-- Expense entries table (same columns as Cashflow; Expense tab only) -->
  <div class="mt-2 overflow-x-auto w-full max-h-[300px]">
    <table class="daybook-table w-full overflow-hidden">
      <thead class="text-[13px] sm:text-sm lg:text-[15px] font-semibold">
        <tr class="text-left bg-white">
          <th>EX NO.</th>
          <th>DATE</th>
          <th>FIRM</th>
          <!-- <th class="whitespace-nowrap">USER NAME</th> -->
          <th class="text-right">CASH</th>
          <th class="text-right" *ngIf="isGst">BANK</th>
          <th class="text-right" *ngIf="isGst">CARD</th>
          <th class="text-right" *ngIf="isGst">ONLINE</th>
          <th class="text-right">DISC</th>
          <th class="text-right">TOTAL</th>
        </tr>
      </thead>
      <tbody class="text-[13px] sm:text-sm lg:text-[15px] font-medium">
        <tr *ngFor="let item of transactions" class="border-b border-483d8b/10 last:border-0 hover:bg-white/60">
          <td class="text-1c1c1c">{{ item.invoice_no }}</td>
          <td class="text-1c1c1c whitespace-nowrap">{{ item.date | date:'dd MMM yyyy' }}</td>
          <td class="text-1c1c1c">{{ item.firm }}</td>
          <!-- <td class="text-c19725 whitespace-nowrap">{{ item.user }}</td> -->
          <td class="text-right" [ngClass]="item.cash >= 0 ? 'text-018f37' : 'text-bb0000'">
            {{ item.cash | number:'1.2-2' }}
          </td>
          <td class="text-right" *ngIf="isGst" [ngClass]="item.bank >= 0 ? 'text-018f37' : 'text-bb0000'">
            {{ item.bank | number:'1.2-2' }}
          </td>
          <td class="text-right" *ngIf="isGst" [ngClass]="item.card >= 0 ? 'text-018f37' : 'text-bb0000'">
            {{ item.card | number:'1.2-2' }}
          </td>
          <td class="text-right" *ngIf="isGst" [ngClass]="item.online >= 0 ? 'text-018f37' : 'text-bb0000'">
            {{ item.online | number:'1.2-2' }}
          </td>
          <td class="text-right" [ngClass]="item.disc >= 0 ? 'text-018f37' : 'text-bb0000'">
            {{ item.disc | number:'1.2-2' }}
          </td>
          <td class="text-right font-bold" [ngClass]="item.total >= 0 ? 'text-018f37' : 'text-bb0000'">
            {{ item.total | number:'1.2-2' }}
          </td>
        </tr>
        <tr *ngIf="transactions.length === 0 && !isLoading">
          <td [attr.colspan]="isGst ? 10 : 7" class="text-center py-8 text-gray-400 italic">
            No expense entries found for this period.
          </td>
        </tr>
        <tr *ngIf="isLoading">
          <td [attr.colspan]="isGst ? 10 : 7" class="text-center py-8 text-483d8b animate-pulse">
            Loading expense entries...
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Amount Table -->
  <div class="transition-all duration-300 ease-in-out overflow-hidden" [class.max-h-0]="!accordionState.expense"
    [class.max-h-[2000px]]="accordionState.expense">
    <div class="mt-2 overflow-x-auto w-full">
      <table class="daybook-table w-full overflow-hidden">
        <thead class="text-right text-[13px] sm:text-sm lg:text-[15px] uppercase font-semibold">
          <tr class="bg-d9d9d9">
            <th class="text-left capitalize text-sm sm:text-base xl:text-base">Transactional Details</th>
            <th [attr.colspan]="!!isGst ? 4 : 1"></th>
            <th class="text-bb0000 whitespace-nowrap">AMOUNT CR</th>
            <th></th>
            <th class="text-018f37 whitespace-nowrap">AMOUNT DR</th>
          </tr>
          <tr class="bg-dcb1ff">
            <th></th>
            <th>CASH</th>
            <th *ngIf="!!isGst">BANK</th>
            <th *ngIf="!!isGst">CARD</th>
            <th *ngIf="!!isGst">ONLINE</th>
            <th>DISC</th>
            <th class="whitespace-nowrap">EXTRA AMT.</th>
            <th>TOTAL</th>
          </tr>
        </thead>
        <tbody class="text-right text-[13px] sm:text-sm lg:text-[15px] uppercase font-medium">
          <tr>
            <td class="text-018f37 whitespace-nowrap">AMOUNT IN :</td>
            <td class="text-018f37">{{ summary.amount_in.cash | number:'1.2-2' }}</td>
            <td class="text-018f37" *ngIf="!!isGst">{{ summary.amount_in.bank | number:'1.2-2' }}</td>
            <td class="text-018f37" *ngIf="!!isGst">{{ summary.amount_in.card | number:'1.2-2' }}</td>
            <td class="text-018f37" *ngIf="!!isGst">{{ summary.amount_in.online | number:'1.2-2' }}</td>
            <td class="text-018f37">{{ summary.amount_in.disc | number:'1.2-2' }}</td>
            <td class="text-bb0000">0.00</td>
            <td class="text-018f37">{{ summary.amount_in.total | number:'1.2-2' }}</td>
          </tr>
          <tr>
            <td class="text-bb0000 whitespace-nowrap">AMOUNT OUT :</td>
            <td class="text-bb0000">{{ summary.amount_out.cash | number:'1.2-2' }}</td>
            <td class="text-bb0000" *ngIf="!!isGst">{{ summary.amount_out.bank | number:'1.2-2' }}</td>
            <td class="text-bb0000" *ngIf="!!isGst">{{ summary.amount_out.card | number:'1.2-2' }}</td>
            <td class="text-bb0000" *ngIf="!!isGst">{{ summary.amount_out.online | number:'1.2-2' }}</td>
            <td class="text-bb0000">{{ summary.amount_out.disc | number:'1.2-2' }}</td>
            <td class="text-bb0000">0.00</td>
            <td class="text-bb0000">{{ summary.amount_out.total | number:'1.2-2' }}</td>
          </tr>
          <tr>
            <td class="text-bb0000 whitespace-nowrap">TODAY TOTAL :</td>
            <td class="text-bb0000">{{ (summary.amount_in.cash - summary.amount_out.cash) | number:'1.2-2' }}</td>
            <td class="text-bb0000" *ngIf="!!isGst">{{ (summary.amount_in.bank - summary.amount_out.bank) |
              number:'1.2-2' }}</td>
            <td class="text-bb0000" *ngIf="!!isGst">{{ (summary.amount_in.card - summary.amount_out.card) |
              number:'1.2-2' }}</td>
            <td class="text-bb0000" *ngIf="!!isGst">{{ (summary.amount_in.online - summary.amount_out.online) |
              number:'1.2-2' }}</td>
            <td class="text-bb0000">{{ (summary.amount_in.disc - summary.amount_out.disc) | number:'1.2-2' }}</td>
            <td class="text-bb0000">0.00</td>
            <td class="text-bb0000">{{ (summary.amount_in.total - summary.amount_out.total) | number:'1.2-2' }}</td>
          </tr>
          <tr>
            <td class="text-554646 whitespace-nowrap uppercase">OPENING BALANCE :</td>
            <td [attr.colspan]="!!isGst ? 6 : 3"></td>
            <td class="text-bb0000">{{ summary.opening_balance | number:'1.2-2' }}</td>
          </tr>
          <tr>
            <td class="text-554646 whitespace-nowrap uppercase italic font-medium">TODAY TOTAL :</td>
            <td [attr.colspan]="!!isGst ? 6 : 3"></td>
            <td class="text-bb0000">{{ (summary.amount_in.total - summary.amount_out.total) | number:'1.2-2' }}</td>
          </tr>
          <tr>
            <td class="text-554646 whitespace-nowrap uppercase font-bold">CLOSING AMOUNT :</td>
            <td [attr.colspan]="!!isGst ? 6 : 3"></td>
            <td class="text-554646 font-bold">{{ summary.closing_balance | number:'1.2-2' }}</td>
          </tr>
        </tbody>
        <tfoot class="text-right text-[13px] sm:text-sm lg:text-[15px] uppercase font-semibold">
          <tr class="bg-d9d9d9">
            <td class="text-black whitespace-nowrap">FINAL TOTAL :</td>
            <td [attr.colspan]="!!isGst ? 6 : 3"></td>
            <td class="text-black">₹ {{ summary.closing_balance | number:'1.2-2' }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>